import Splide from '@splidejs/splide';

const hero = document.querySelector('.hero');

var sliderExists = document.getElementsByClassName('hero__slider');
if( sliderExists.length > 0 ){
    const heroSlider = hero.querySelector('.hero__slider');

    // hero slider
    if( heroSlider ) {
        var splide = new Splide( '.hero__slider' , {
            type: 'fade',
            rewind: true,
            speed: 4000,
            interval: 7000,
            autoplay: true,
            arrows: false,
            pagination: false,
            perPage: 1,
            perMove: 1
        });
        splide.mount();
    }
}